import React, { Component } from 'react'
import { Layout } from 'antd'

import classNames from 'classnames'

// redux
import { connect } from 'react-redux'
import appActions from '../../../redux/app/actions'

// icon
import { FaBars } from 'react-icons/fa'

// subcomponent
import AvatarUser from './avatarUser'
import TopbarNotification from './topbarNotification'
import Marquee from 'react-smooth-marquee'
import TopbarWrapper from './topbar.style'
import NotifyAction from '../../../redux/Notify/actions'
import organizationActions from '../../../redux/organization/actions'
const { Header } = Layout

class TopBar extends Component {
    componentDidMount() {
        this.props.loadListOrganizations(0)
    }
    getNameOfCurrent = name => {
        switch (name) {
            case 'dashboard':
                return 'Bảng điều khiển'
            case 'users':
                return 'Quản lý người dùng'
            case 'organization-management':
                return 'Quản lý đơn vị'
            case 'qbtask':
                return 'Nhiệm vụ đơn vị'
            case 'qbobjects':
                return 'Quản lý đối tượng'
            case 'qbevents':
                return 'Quản lý sự kiện'
            case 'qbmedias':
                return 'Quản lý tài liệu'
            case 'qbreport':
                return 'Quản lý báo cáo'
            case 'qbrole':
                return 'Cài đặt phân quyền'
            case 'message':
                return 'Báo cáo nhanh'
            default:
                return ''
        }
    }
    getNameOfTier = name => {
        switch (name) {
            case 1:
                return 'Tier1'
            case 2:
                return 'Tier2'
            case 3:
                return 'Tier3'
            case 4:
                return 'Đơn vị vùng'
            case 90:
                return 'Trung tâm trinh sát'
            case 99:
                return 'Quân báo trinh sát'
            case 100:
                return 'Quản trị hệ thống'
            case 'qbreport':
                return 'Quản lý báo cáo'

            default:
                return ''
        }
    }
    getSessionDay = () => {
        let today = new Date()
        let curHr = today.getHours()
        if (curHr < 12) {
            return 'Chào buổi sáng: '
        } else if (curHr < 18) {
            return 'Chào buổi chiều: '
        } else {
            return 'Chào buổi tối: '
        }
    }
    getNameOfOrg = org_id => {
        let crrOrg = this.props.organizations.find(value => {
            return value.oid === org_id
        })
        console.log('this.props.currentorg', org_id)
        if (crrOrg) {
            return ' thuộc ' + crrOrg.name
        } else {
            return ''
        }
    }
    render() {
        console.log('this.props.user org', this.props.userInfo)
        const { toggleCollapsed } = this.props
        return (
            <TopbarWrapper>
                <Header className="isomorphicTopbar ">
                    <div className="isoLeft">
                        <div
                            className="buttonCollapse"
                            style={{
                                justifyContent: 'center',
                            }}
                        >
                            <FaBars
                                onClick={toggleCollapsed}
                                style={{ fontSize: 22, color: 'white' }}
                            />{' '}
                            <text
                                style={{
                                    color: 'white',

                                    paddingLeft: 10,
                                    fontSize: 20,
                                    fontWeight: '400',
                                }}
                            >
                                {this.getNameOfCurrent(this.props.current[0])}
                            </text>
                        </div>
                    </div>
                    <div
                        style={{
                            color: '#a0c4a8',

                            position: 'sticky',
                            height: 60,
                        }}
                    >
                        {this.props.userInfo && this.props.organizations && (
                            <text>
                                {this.getSessionDay()}
                                {this.props.userInfo.display_name} (
                                {this.getNameOfTier(
                                    this.props.userInfo.tier_id
                                )}
                                {this.getNameOfOrg(
                                    this.props.userInfo.organ_id
                                )}
                                )
                            </text>
                        )}
                    </div>
                    <ul className={classNames('row', 'isoRight')}>
                        <li className="isoNotify" style={{ marginRight: 15 }}>
                            <TopbarNotification locale={'en'} />
                        </li>
                        <li style={{ marginRight: 15 }}>
                            <AvatarUser />
                        </li>
                    </ul>
                </Header>
            </TopbarWrapper>
        )
    }
}

const mapStateToProps = state => {
    return {
        current: state.app.current,
        organizations: state.organization.organizations,
        userInfo: state.auth.userInfo,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        toggleCollapsed: () => {
            dispatch(appActions.toggleCollapsed())
        },
        loadListOrganizations: loadType => {
            dispatch(organizationActions.action.loadListOrganization(loadType))
        },
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(TopBar)
